import React from 'react'
import './src/styles/global.css'
import WebContextProvider from './src/context'


export const wrapRootElement = ({ element }) => (
  <WebContextProvider>{element}</WebContextProvider>
)
